export default __webpack_public_path__ + "static/compareItemImg3-f97c6782de16e58da0fe92b30c7be563.png";